export const HOME_MATCH_RESIGNATION_SURVEY_CONTENT = {
    SUBMIT_BUTTON: "Wyłącz usługę",
    TITLE: "Dlaczego chcesz zrezygnować z usługi automatycznych zapytań Homematch?"
} as const;
export const HOME_MATCH_RESIGNATION_SURVEY_CONTENT = {
    SUBMIT_BUTTON: "Wyłącz usługę",
    TITLE: "Dlaczego chcesz zrezygnować z usługi automatycznych zapytań Homematch?"
} as const;
